// Dependency-free module-license predicates shared across routes, pages, and data defs.
// Kept import-free so widely-imported modules (e.g. ActionData) don't eagerly pull in page components.

export const validatePatchModuleLicense = (has: (module: string) => boolean) =>
	has('patch_management') && (has('app_control') || has('vuln_assessment'));

// Named license predicates addressable from data files (e.g. whats-new.json), where `perm` can only be a string.
// A perm string is either a plain module key (checked against device modules) or one of these predicate names.
export const permPredicates = {validatePatchModuleLicense} as const;

export type PermPredicateName = keyof typeof permPredicates;

// Resolves a data-file `perm` string to the predicate function it names, or returns the string unchanged
// so checkModuleLicense treats it as a plain module key. Undefined perm (all customers) passes through.
export const resolvePerm = (perm?: string) =>
	perm && perm in permPredicates ? permPredicates[perm as PermPredicateName] : perm;
